var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BilletInfo } from "@/components/common/BilletInfo";
import { Breadcrumbs } from "@/components/common/Breadcrumbs";
import { Container } from "@/components/common/Container";
import { EvaluateServiceButton } from "@/components/common/EvaluateServiceButton";
import { MerchanApp } from "@/components/common/MerchanApp";
import { PageTitle } from "@/components/common/PageTitle";
import { RequestProof } from "@/components/common/RequestProof";
import { ServiceInfo, ServiceInfoItem } from "@/components/common/ServiceInfo";
import { useSolicitation } from "@/hooks/useSolicitation";
import { ROUTES } from "@/routes/routes";
import GatewayService from "@/services/api/GatewayService";
import { TriangleAlert } from "lucide-react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { DialogBoletoDetails } from "./components/DialogBoletoDetails";
export function Tax() {
    var solicitation = useSolicitation().solicitation;
    var history = useHistory();
    var service = new GatewayService();
    var _a = useState(false), showBoleto = _a[0], setShowBoleto = _a[1];
    var hasLoadedSolicitation = Object.keys(solicitation).length > 0;
    useEffect(function () {
        if (!hasLoadedSolicitation) {
            history.replace(ROUTES.HOME);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [solicitation]);
    var BREADCRUMB_ITEMS = [
        {
            name: "Página Inicial",
            path: "https://portal.pi.gov.br/detran/",
        },
        {
            name: "Solicitar PID",
            path: ROUTES.HOME,
            current: true,
        },
    ];
    if (!hasLoadedSolicitation)
        return null;
    return (_jsxs(Container, { children: [_jsx(Breadcrumbs, { pages: BREADCRUMB_ITEMS }), _jsx(PageTitle, { title: "Permiss\u00E3o Internacional para Dirigir - PID" }), _jsxs("div", __assign({ className: "w-full max-w-[856px] flex flex-col gap-2" }, { children: [_jsx(ServiceInfo, { children: _jsx(ServiceInfoItem, { title: "Sua solicita\u00E7\u00E3o foi criada!", content: [
                                "Pague a taxa pendente abaixo para validar sua solicitação:",
                            ], listType: "none" }) }), _jsx(BilletInfo, { serviceName: "Permissão Internacional para Dirigir - PID", data: solicitation, handleShowBoleto: setShowBoleto })] })), _jsxs("section", __assign({ className: "w-full max-w-[856px] bg-warning text-warning-foreground flex flex-col justify-between px-6 py-3 rounded-lg" }, { children: [_jsxs("div", __assign({ className: "flex items-center gap-2 py-2" }, { children: [_jsx(TriangleAlert, {}), _jsx("span", __assign({ className: "font-medium text-center" }, { children: "Aten\u00E7\u00E3o!" }))] })), _jsx("p", __assign({ className: "font-normal" }, { children: "Caso o pagamento n\u00E3o seja confirmado em at\u00E9 15 dias, o protocolo ser\u00E1 CANCELADO automaticamente." }))] })), _jsx("section", __assign({ className: "hidden lg:block w-full max-w-[856px] rounded-lg p-6 border-l-2 border-r-2 border-t-2 border-b-2 bg-secondary text-secondary-foreground space-y-6 border-none" }, { children: _jsx(RequestProof, { data: solicitation }) })), _jsx("section", { children: _jsx(MerchanApp, {}) }), _jsx(EvaluateServiceButton, {}), _jsx(DialogBoletoDetails, { data: solicitation, service: service, showBoleto: showBoleto, setShowBoleto: setShowBoleto })] }));
}
